export const splitPascalCaseToWords = string => {
  return string.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1");
};
